import { Avatar, Button, Card, Group, MantineTheme, Stack, Text, Title } from "@mantine/core";
import { Entity, EntityDefinition, latLng, RecordGroupManager, useEntityUI, ValuesRecord } from "@mcurros2/microm";
import { IconAlertCircle, IconCircleCheck, IconHelpCircle } from "@tabler/icons-react";
import { Dashboard } from "./Dashboard";

export function PersonalLocalizacionViewInfoWindowRenderer(
    record: ValuesRecord,
    position: latLng,
    groupManager: RecordGroupManager,
    infoWindow: google.maps.InfoWindow,
    UIAPI: ReturnType<typeof useEntityUI>,
    theme: MantineTheme,
    entity: Entity<EntityDefinition>
) {
    const dashboard = entity as Dashboard;

    const personal_id = record[0] as string;
    const apellido = record[3] as string;
    const nombre = record[4] as string;
    const fecha = record[5] as string;
    const puesto = record[6] as string;
    const vc_fotoguid = record[19] as string;
    const visitas = record[21] as string;

    const fotoURL = entity.API.client.getDocumentURL(vc_fotoguid);

    const group = groupManager.getGroupByLocation(position);

    const warningColor = theme.colorScheme === "dark" ? theme.colors.orange[5] : theme.colors.orange[7];
    const okColor = theme.colorScheme === "dark" ? theme.colors.green[5] : theme.colors.green[7];
    const errorColor = theme.colorScheme === "dark" ? theme.colors.red[5] : theme.colors.red[7];

    if (group) {
        return (
            <Card withBorder>
                <Stack spacing="xs" mb="xs">
                    {group.records.map(
                        ({ recordValue: rec }, index) => <Group key={`grp_${rec[0]}`}>
                            <Title order={5}>{`${rec[3]}, ${rec[4]} - Fecha Localización: ${rec[5]}`}</Title>
                        </Group>
                    )
                    }
                    <Group position="right">
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
    else {
        const client = entity.API.client;

        return (
            <Card withBorder padding="xs">
                <Stack spacing="0.5rem">
                    <Group spacing="xs">
                        <Avatar size="md" src={fotoURL} radius="sm" />
                        <Title order={4}>{`${apellido}, ${nombre}`}</Title>
                    </Group>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">Fecha Localización: </Text>
                        {fecha}
                    </Group>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">Puesto: </Text>
                        {puesto}
                    </Group>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">
                            Visitas:
                            {visitas.split('--').map((line, index) => (

                                <Text key={index}>
                                    {line.includes('Sin iniciar') ? (
                                        <>
                                            {line.split('Sin iniciar')[0]}
                                            <IconAlertCircle color={errorColor} />
                                            {line.split('Sin iniciar')[1]}
                                        </>
                                    ) : line.includes('En proceso') ? (
                                        <>
                                            {line.split('En proceso')[0]}
                                            <IconHelpCircle color={warningColor} />
                                            {line.split('En proceso')[1]}
                                        </>
                                    ) : line.includes('Finalizada') ? (
                                        <>
                                            {line.split('Finalizada')[0]}
                                            <IconCircleCheck color={okColor} />
                                            {line.split('Finalizada')[1]}
                                        </>
                                    ) : (
                                        line
                                    )}
                                </Text>

                            ))}
                        </Text>
                    </Group>
                    <Group position="right">
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
}